export default __webpack_public_path__ + "static/media/venture_image3.19799291.svg";